"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _require = require("../mapValues"),
    mapValues = _require.mapValues;

var isObjectButNotNull = function isObjectButNotNull(obj) {
  return obj !== null && _typeof(obj) === "object";
};

var ConvertersComposer = /*#__PURE__*/function () {
  function ConvertersComposer() {
    _classCallCheck(this, ConvertersComposer);

    for (var _len = arguments.length, converters = new Array(_len), _key = 0; _key < _len; _key++) {
      converters[_key] = arguments[_key];
    }

    this._converters = converters;
  }

  _createClass(ConvertersComposer, [{
    key: "convertToCustomFormat",
    value: function convertToCustomFormat(obj) {
      var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      var inArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (isObjectButNotNull(obj)) {
        if (parents.has(obj)) {
          throw new TypeError("Converting circular structure to JSON");
        } else {
          parents.add(obj);
        }
      }

      if (Array.isArray(obj)) {
        return this._convertArray(obj, parents);
      }

      var serialized = this._findConverterToCustomFormat(obj).convertToCustomFormat(obj, inArray);

      return isObjectButNotNull(obj) ? this._convertObject(serialized, obj, parents) : serialized;
    }
  }, {
    key: "convertFromCustomFormat",
    value: function convertFromCustomFormat(obj) {
      var _this = this;

      var preprocessedObj = obj;

      if (Array.isArray(obj)) {
        preprocessedObj = obj.map(function (arrayMember) {
          return _this.convertFromCustomFormat(arrayMember);
        });
      } else if (isObjectButNotNull(obj)) {
        preprocessedObj = mapValues(obj, this.convertFromCustomFormat.bind(this));
      }

      return this._findConverterFromCustomFormat(preprocessedObj).convertFromCustomFormat(preprocessedObj);
    }
  }, {
    key: "_convertObject",
    value: function _convertObject(serialized, obj, parents) {
      var _this2 = this;

      var result;

      if (typeof serialized.toJSON === "function") {
        result = mapValues(serialized.toJSON(), function (value) {
          return _this2.convertToCustomFormat(value, parents);
        });
      } else {
        result = mapValues(serialized, function (value) {
          return _this2.convertToCustomFormat(value, parents);
        });
      }

      parents.delete(obj);
      return result;
    }
  }, {
    key: "_convertArray",
    value: function _convertArray(obj, parents) {
      var _this3 = this;

      var result = obj.map(function (arrayMember) {
        return _this3.convertToCustomFormat(arrayMember, parents, true);
      });
      parents.delete(obj);
      return result;
    }
  }, {
    key: "_findConverterFromCustomFormat",
    value: function _findConverterFromCustomFormat(obj) {
      return this._converters.find(function (candidate) {
        return candidate.canConvertFromCustomFormat(obj);
      });
    }
  }, {
    key: "_findConverterToCustomFormat",
    value: function _findConverterToCustomFormat(obj) {
      return this._converters.find(function (candidate) {
        return candidate.canConvertToCustomFormat(obj);
      });
    }
  }]);

  return ConvertersComposer;
}();

module.exports = {
  ConvertersComposer: ConvertersComposer
};